import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-790aa026"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody D-Flex" }
const _hoisted_4 = { class: "CookiesRow F-C2" }
const _hoisted_5 = { class: "CookiesRow W-100" }
const _hoisted_6 = { class: "CookiesRow P1em" }
const _hoisted_7 = {
  class: "M-Auto CookiesButton Rad3 BG2 Shadow1 Color3 HoverGlow",
  style: {"padding":"0.5em 1em"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_9 = { class: "M-Auto F-Bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    (_ctx.Saving)
      ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CookiesIcon, {
        ID: ('Reports' as IconsIDs),
        style: {"width":"3.5em","height":"3.5em","padding":"1.5em"},
        class: "M-Auto Shadow1"
      }, null, 8, ["ID"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.Translate('Choose CSV file')) + " ", 1),
                _createElementVNode("input", {
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ParseCSV())),
                  style: {"width":"0","height":"0","display":"none"},
                  type: "file",
                  accept: ".csv"
                }, null, 32)
              ])
            ]),
            (_ctx.CSVLoaded)
              ? (_openBlock(), _createBlock(_component_CookiesTable, {
                  key: 0,
                  class: "F_75em",
                  CookiesData: _ctx.Data,
                  TableSettings: _ctx.TableSettings
                }, null, 8, ["CookiesData", "TableSettings"]))
              : _createCommentVNode("", true),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
              style: _normalizeStyle('background: ' + _ctx.Theme.Shade3),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 5),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.SendMessages())),
              class: _normalizeClass(["F-Bold CookiesButton DialogFooterButton BGMain", _ctx.DataIsValid ? '' : 'Disabled'])
            }, _toDisplayString(_ctx.Translate('Import')), 3)
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}